import { HttpVerb } from "../../constants";

const getToken = async () => {
  return window.ucSDK.api.instance?.authenticatedRequest({
    url: "/api/GetToken",
    method: HttpVerb.GET
  });
};

export default {
  getToken
};
